export const storageManager = {
  get(key) {
    return localStorage.getItem(key);
  },
  set(key, value) {
    localStorage.setItem(key, value);
  },
  remove(key) {
    localStorage.removeItem(key);
  },
  reset() {
    localStorage.clear();
  },
  getMobileSettings() {
    let mobileSettings = {};
    try {
      mobileSettings = JSON.parse(this.get("mobileSettings"));
      if (typeof mobileSettings !== "object" || !mobileSettings) {
        throw new Error();
      }
    } catch {
      mobileSettings = {};
    }
    return mobileSettings;
  },
  hasMobileSettings() {
    return Object.keys(this.getMobileSettings()).length > 0;
  },
  getPendingFeedbacks() {
    let pendingFeedbacks = [];
    try {
      pendingFeedbacks = JSON.parse(this.get("pendingFeedbacks"));
      if (!Array.isArray(pendingFeedbacks)) {
        throw new Error();
      }
    } catch {
      pendingFeedbacks = [];
    }
    return pendingFeedbacks;
  },
  hasPendingFeedbacks() {
    return !!this.get("pendingFeedbacks");
  }
};

export default ({ Vue }) => {
  Vue.prototype.$storage = storageManager;
};
